import { render, staticRenderFns } from "./active-business.vue?vue&type=template&id=9cbd0446"
import script from "./active-business.vue?vue&type=script&lang=js"
export * from "./active-business.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports